import { type ToastOptions, toast } from 'react-toastify'

export const toastInfo = (message: string, options?: ToastOptions) => {
	toast.info(message, options)
}
